"use strict";

var LoggerInstance = require("js-logger").get("AccountDemographicsHelper");

var ValidationHelper = require("./ValidationHelper");

var InputHelper = require("../shared/InputHelper");

// AccountDemographicsHelper
module.exports = {
	getDemographics: function ($namedInputs, shouldValidate) {
		var deferred = new $.Deferred();

		shouldValidate = (shouldValidate === undefined ? true : !!shouldValidate);

		// If nothing was passed in, assume we need to get inputs from the entire layout
		if (!$namedInputs) {
			//We always want to get [data-component='singleCheckbox.input'] because it has a true/false value.
			$namedInputs = $("[data-component='accountDemographicsForm']").find("[name].isDirty,[name][required],[data-component='singleCheckbox.input']");
		}

		if ($namedInputs.length <= 0) {
			deferred.resolve();
			return deferred;
		}

		// This will handle the singleCheckbox, radioButtons, and select 'required' inputs.
		// We then need to ensure that at least one 'required' multi-value checkbox is selected.
		var getInputValues = () => {
			var demographicsCollection = InputHelper.getGeneralInputValues($namedInputs);

			// remove the isDirty flag so any new changes will get it
			$namedInputs.removeClass("isDirty");
			deferred.resolve(demographicsCollection);
		};

		if (shouldValidate) {
			ValidationHelper.validate({
				components: $.map($namedInputs, (element) => $(element))
			}).always(isValid => {
				$('[data-component="multipleCheckboxes"][required]').each((index, component) => {
					if (!$(component).find("input:checked").length) {
						isValid = false;
						ValidationHelper.showInvalidInputsDialog();
					}
				});

				if (!isValid) {
					deferred.resolve();
				}

				getInputValues();
			});
		} else {
			getInputValues();
		}

		return deferred;
	},

	updateSelectedCheckboxes: function ($selectedCheckbox, isChecked) {
		var $currentComponent = $selectedCheckbox.closest('[data-component="multipleCheckboxes.singleCheckbox"]');
		if (isChecked) {
			$currentComponent.addClass("selected");
			$currentComponent.find("label").addClass("selected");
		} else {
			$currentComponent.removeClass("selected");
			$currentComponent.find("label").removeClass("selected");
		}
	},

	updateSelectedRadioButtons: function ($selectedRadio) {
		// remove old ones
		$selectedRadio.closest('[data-component="radioButtons"] .radio-buttons-wrapper').find(".selected").removeClass("selected");

		// add to this one
		var $currentComponent = $selectedRadio.closest('[data-component="radioButtons.singleRadioButton"]');
		$currentComponent.addClass("selected");
		$currentComponent.find("label").addClass("selected");
	}
};
